import {
   type CountryCode,
   type LanguageCode,
   ShopifyStorefrontProvider,
} from '@ifixit/shopify-storefront-client';
import { initializeChakraComponent } from 'Shared/chakra-initialize';
import { useState } from 'react';
import { UserCard } from './Sidebar/user_card';
import { UserTabs } from './user_tabs';
import { UserView } from './user_view';
import {
   faAddressCard,
   faBell,
   faStore,
   faFiles,
   faListTimeline,
   faCertificate,
   faGrid2,
   faCalendarCheck,
} from '@fortawesome/pro-solid-svg-icons';
import type { VoteHistoryDataType } from './vote_history';
import type { UserSummaryType } from './Sidebar/user_card';

export type SidebarDataType = {
   userCardData: UserSummaryType;
   certData?: any;
   voteHistoryData?: VoteHistoryDataType;
};

function getInitialUnreadNotifCount(viewData: any): number {
   for (const viewDatum of viewData) {
      if (viewDatum.name === 'Notifications') {
         return viewDatum.data.notif_count;
      }
   }
   return 0;
}

const UserPage = ({
   userid,
   viewData,
   sidebarData,
   activeTab,
   shopifyStore,
}: {
   userid: number;
   viewData: any[];
   editUrl?: string;
   usersUrl: string;
   sidebarData: SidebarDataType;
   activeTab: string;
   shopifyStore: {
      currencyCode: string;
      country: CountryCode;
      language: LanguageCode;
      storeCode: string;
      shopDomain: string;
      storefrontAccessToken: string;
   };
}) => {
   const [currentTab, setCurrentTab] = useState(activeTab);
   const [unreadNotifCount, setUnreadNotifCount] = useState(getInitialUnreadNotifCount(viewData));
   const tabIcons = {
      'About': faAddressCard,
      'Devices': faGrid2,
      'Contributions': faFiles,
      'Activity': faListTimeline,
      'Reputation': faCertificate,
      'Notifications': faBell,
      'Orders': faStore,
      'Subscriptions': faCalendarCheck,
   };

   return (
      <ShopifyStorefrontProvider {...shopifyStore}>
         <div className="flex max-md:flex-col justify-between gap-8 md:gap-12 mx-auto max-w-[1024px] mt-4 md:mt-16">
            {!App.isOnMobileApp && (
               <div className="flex flex-col gap-4 min-lg:w-[320px]">
                  <UserCard {...sidebarData.userCardData} />
                  <UserTabs
                     viewTabs={viewData}
                     notifBadge={unreadNotifCount}
                     currentTab={currentTab}
                     setCurrentTab={setCurrentTab}
                     tabIcons={tabIcons}
                  />
               </div>
            )}
            <UserProfileDisplay
               userid={userid}
               viewData={viewData}
               currentTab={currentTab}
               setUnreadNotifCount={setUnreadNotifCount}
            />
         </div>
      </ShopifyStorefrontProvider>
   );
};

const UserProfileDisplay = ({
   userid,
   viewData,
   currentTab,
   setUnreadNotifCount,
}: {
   userid: number;
   viewData: any[];
   currentTab: string;
   setUnreadNotifCount: (count: number) => void;
}) => {
   const selectedTab = viewData.find((tab: any) => tab.name === currentTab);
   return (
      <UserView
         userid={userid}
         currentTab={selectedTab}
         setUnreadNotifCount={setUnreadNotifCount}
      />
   );
};

initializeChakraComponent('UserPage', UserPage);
